import { getSexName } from '@/app/common/converters/configuration/sexToTextConverter'
import { getIdentityDocumentTypeName } from '@/app/common/converters/identityDocumentTypeToTextConverter'
import { getLicenseTypeName } from '@/app/common/converters/licenseTypeToTextConverter'
import { Sex } from '@/app/constants/configuration/sex'
import { IdentityDocumentType } from '@/app/constants/identityDocumentType'
import { LicenseType } from '@/app/constants/licenseType'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const useDriverFieldSetOptions = () => {
  const { t } = useLocalize()

  const driverSexOptions = Object.values(Sex)
    .filter((v) => typeof v === 'number')
    .map((ct) => ({
      value: ct,
      label: getSexName(ct, t),
    }))
  const driverIdOptions = Object.values(IdentityDocumentType)
    .filter((v) => typeof v === 'number')
    .map((ct) => ({
      value: ct,
      label: getIdentityDocumentTypeName(ct, t),
    }))
  const driverLicenceOptions = Object.values(LicenseType)
    .map((ct) => ({
      value: ct,
      label: getLicenseTypeName(ct, t),
    }))
    
  return {
    driverSexOptions,
    driverIdOptions,
    driverLicenceOptions,
  }
}

export default useDriverFieldSetOptions
